import React from "react";

type Props = Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  src: any;
  alt: string;

  // next/image-like props (ignored or approximated)
  fill?: boolean;
  sizes?: string;
  priority?: boolean;
  quality?: number;
};

export default function Image({
  src,
  alt,
  fill,
  style,
  ...rest
}: Props) {
  const resolvedSrc = typeof src === "string" ? src : src?.src || "";

  // If fill=true, mimic it with absolute positioning (common usage)
  const mergedStyle: React.CSSProperties =
    fill
      ? {
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          ...style,
        }
      : { ...style };

  return <img src={resolvedSrc} alt={alt} style={mergedStyle} {...rest} />;
}
